import { createApp } from 'vue'
import DirectSupport from './DirectSupport.vue';

var directSupportAppContainer = document.getElementById('direct-support-app');
if (directSupportAppContainer) {
  /*
  new Vue({
    el: directSupportAppContainer,
    render (h) {
        return h(DirectSupport, {props: {
          org: window.ORG, // provided in html JS
          widgetSettings: window.WIDGET_SETTINGS,
        }});
    }
  });
  */

  let directSupportApp = createApp(DirectSupport, 
    {
      org: window.ORG, // provided in html JS
      widgetSettings: window.WIDGET_SETTINGS,
    }
  );
  directSupportApp.mount('#direct-support-app');
}
